module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/54.4e55169d.png";